export enum GameState {
  CREATED = "CREATED",
  NIGHT = "NIGHT",
  DAY = "DAY",
}
